module.exports = __webpack_public_path__ + "static/1-96cc975ef2f6fa23230f8ec0fabc8caa.jpg";